import { patientDemographicsService } from '@/services/patient-demographics-service'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import {
  CREATE_PATIENT_DEMOGRAPHICS,
  UPDATE_PATIENT_DEMOGRAPHICS,
  DELETE_PATIENT_DEMOGRAPHICS,
  GET_PATIENT_DEMOGRAPHICS,
  SET_PATIENT_DEMOGRAPHICS
} from '@/store/mutation-types'

import { denormalize, normalize } from 'normalizr'
import { schemas } from '@/store/schemas'
import _ from 'lodash'

export const mutations = {
  [SET_PATIENT_DEMOGRAPHICS](state, demographics) {
    const result = normalize(demographics, schemas.patientDemographics)
    state.patientDemographics = result.entities.patientDemographics
    state.races = { ...state.races, ...result.entities.races }
    state.ethnicities = { ...state.ethnicities, ...result.entities.ethnicities }
    state.genders = { ...state.genders, ...result.entities.genders }
  }
}

export const actions = {
  async [CREATE_PATIENT_DEMOGRAPHICS]({ dispatch, getters }, { patient, demographics }) {
    const denormalizedPatient = denormalize(
      patient.id,
      schemas.patient,
      getters.getNormalizedState()
    )
    demographics.patient = denormalizedPatient
    await patientDemographicsService.create(MyActiveOrganization.id, demographics)
    dispatch(GET_PATIENT_DEMOGRAPHICS, { patientId: demographics.patient.id })
  },
  async [UPDATE_PATIENT_DEMOGRAPHICS]({ dispatch }, { demographics }) {
    await patientDemographicsService.update(MyActiveOrganization.id, demographics)
    dispatch(GET_PATIENT_DEMOGRAPHICS, { patientId: demographics.patient.id })
  },
  async [DELETE_PATIENT_DEMOGRAPHICS]({ dispatch }, { demographics }) {
    await patientDemographicsService.delete(MyActiveOrganization.id, demographics)
    dispatch(GET_PATIENT_DEMOGRAPHICS, { patientId: demographics.patient.id })
  },
  async [GET_PATIENT_DEMOGRAPHICS]({ commit }, { patientId }) {
    try {
      const response = await patientDemographicsService.findByPatientId(
        MyActiveOrganization.id,
        patientId
      )
      commit(SET_PATIENT_DEMOGRAPHICS, response.data)
    } catch (e) {
      commit(SET_PATIENT_DEMOGRAPHICS, {})
    }
  }
}

export const getters = {
  getPatientDemographicsByPatientId: state => patientId => {
    return _.find(_.map(state.patientDemographics), it => (it.patient = patientId))
  },
  getPatientDemographicsViewModel: (state, getters) => id => {
    return denormalize(id, schemas.patientDemographics, getters.getNormalizedState())
  }
}
